import ReactDom from "react-dom";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import ModalForm from "./ModalForm";

const Backdrop = (props) => {
    console.log(props)
    return (
        <div className="fixed z-40 top-0 left-0 w-full h-full bg-black bg-opacity-60" onClick={props.onClose}>
        </div>
    );
};

const MailchimpForm = props => {

    const postUrl = `https://tonder.us17.list-manage.com/subscribe/post-json?u=${process.env.REACT_APP_MAIL_CHIMP_U}&id=${process.env.REACT_APP_MAIL_CHIMP_ID}`;
    return (
        <MailchimpSubscribe
            url={postUrl}
            render={({ subscribe, status, message }) => (
                <ModalForm
                    onClose={props.onclose}
                    status={status}
                    message={message}
                    onValidated={formData => subscribe(formData)}
                />
            )}
        />
    );
}

const portalElement = document.getElementById('overlay');

export default function MailchimpFormContainer(props) {

    return (
        <>
            {ReactDom.createPortal(<Backdrop onClose={props.onClose} />, portalElement)}
            {ReactDom.createPortal(<MailchimpForm />, portalElement)}
        </>
    );
}
